<template>
  <div>
    <b-form-select v-model="selected" :options="options" v-bind="$attrs">
      <template #first>
        <b-form-select-option :value="null" disabled>{{placeholder}}</b-form-select-option>
      </template>
    </b-form-select>
  </div>
</template>

<script>

export default {
  name: "sales-report-payment-status-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        { value: 'paid', text: 'Lunas' },
        { value: 'unpaid', text: 'Belum Dibayar' },
        { value: 'partially', text: 'Kurang Bayar' }
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val){
      this.selected = val || null 
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
